import Button from '@material-ui/core/Button'
import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

interface Props extends RouteComponentProps {
  logout: () => void
}

const LogoutButton: React.FC<Props> = ({ logout, history }) => {
  const handleClick = (): void => {
    logout()
    history.push('/login')
  }
  return (
    <Button style={{ color: '#ffffff' }} onClick={handleClick}>
      Logout
    </Button>
  )
}

export default withRouter(LogoutButton)
